// @flow
import React, {useContext, useEffect, useState} from 'react';
import * as PropTypes from 'prop-types';
import TextInput from '../GUI_COMMON/COMPONENTS/TextInput';
import LoadingSpinner from "../GUI_COMMON/COMPONENTS/LoadingSpinner";
import LocationSelector from "./LocationSelector";
import ContactFind from "./ContactFind";
import DatePicker from 'react-date-picker'
import SamplesList, {SampleListWillReturnNothing} from "./SamplesList";
import CaseFind from "./CaseFind";
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import CalendarIcon from "./CalendarIcon";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";
import SampleBarcodeFind from "./SampleBarcodeFind";
import NotesEditor from "./NotesEditor";
import Popup from "../GUI_COMMON/COMPONENTS/Popup";

const RetrievalOrderForm = ({retrievalInfo, onChange, onSubmit, onAddSamples, onAddSamplesViaBarcode, onDateChanged, onSampleClicked, onSampleOrderClicked,
                                onRemoveSample, onSampleRepairClicked, goodNess, formIsValid, isSaving, formIsReadOnly, isDirty, onAddNoteClicked, newlyAddedSampleIds}) => {
    
    const [globalState] = useContext(StoreContext);
    const [dateControlInputClass,setDateControlInputClass] = useState("form-control p-0");
    const [locationIsValid, setLocationIsValid] = useState(false);      // set to true if the location component is satisfied with the current selection
    
    useEffect( () => {
        setDateControlInputClass(getDateValidationClassGivenValue(retrievalInfo.dueBackDate, !formIsReadOnly, formIsReadOnly));
    }, [retrievalInfo,formIsReadOnly]) // eslint-disable-line react-hooks/exhaustive-deps

    function dueBackDateIsGood(theDate) {
        if(!theDate) return false;
        const ticks = theDate.getTime();
        return ticks>Date.now();
    }
    
    function getDateValidationClassGivenValue(dueBackDate, isRequired, isReadOnly) {
        let inputClass = 'form-control li-form-field p-0';
        if(isReadOnly) {
            inputClass += ' muted';
            return inputClass;
        } // readonly is always muted.

        let markWith= "good"; // good by default 
        if(isRequired) {
            markWith=dueBackDateIsGood(dueBackDate)?"good":"bad";
        }

        // update color
        if(markWith==="bad") inputClass += ' li-border-danger'; // mark bad
        else if(markWith==="good") inputClass += ' li-border-good' ; // mark good

        return inputClass;
    }
    
    function dumpPermanentRemoveCheckBox() {
        return (
            <div className="text-left">
                <input type="checkbox" className="m-2 mr-3 border-bottom" id="permanentlyRemove" name="permanentlyRemove"
                       aria-label="Checkbox" checked={retrievalInfo?.permanentlyRemove ?? false}
                       onChange={onChange} readOnly={formIsReadOnly}/>
                <label className="li-form-label" htmlFor="permanentlyRemove">Mark these all for <span className="li-fg-danger font-weight-bold">Permanent Removal</span></label>
            </div>
        );
    }
    
    if(formIsReadOnly===true) {  // define some default empty functions to avoid browser errors when form is in readonly mode.
        onChange=() =>{};
        onAddSamples=()=>{};
    }
    
    function isNewOrder() {
        return retrievalInfo?.orderId==="" || retrievalInfo?.orderId === -1
    }
    
    function onLocationIsValidChanged(isValid) {
        console.log(`*location* isValid=${isValid}`);
        setLocationIsValid(isValid);
    }

    function dumpSelectedSamplesList() {
        let someSamplesAreSelected=false;
        let sampleListMap = globalState.sampleTypes.items.map( (type) => {
            if(SampleListWillReturnNothing(retrievalInfo?.samples??[],type.id)) return null;
            someSamplesAreSelected=true;
            return (
                <div key={"sampleType_"+type.id} id={"sampleList-"+type.id}>
                    <hr className="li-bg-dark"/>
                    <h3 className="li-header-row li-border-muted li-bg-white p-1">{type.name}</h3>
                    {/*<hr className="li-bg-dark"/>*/}
                    <SamplesList name={type.id+"-cb"} samples={retrievalInfo?.samples??[]} sampleType={type.id}
                                 onSampleClicked={onSampleClicked}
                                 onOrderClicked={onSampleOrderClicked} 
                                 showDelete onDeleteClicked={onRemoveSample}
                                 onRepairClicked={onSampleRepairClicked}
                                 readOnly={formIsReadOnly}
                                 thisOrderId={retrievalInfo.orderId} returnNullOnNoneFound
                                 profiles={globalState.profiles?.items??[]}
                                 newlyAddedSampleIds={newlyAddedSampleIds}/>
                </div>);
        });
        if(!someSamplesAreSelected) {
            return <div className="p-2">No samples selected</div>;
        }
        return sampleListMap;
    }
    
    function handleLocationHelpClicked() {
        Popup.show("Locations", 
            "<p>Any locations that are \"Off Premises\" are not available for retrievals and will not appear in the locations list.</p>");
    }
    
    return (
        <form id="retrievalOrderForm">
            {formIsReadOnly && <h6 className="text-right li-fg-slightly-muted">
                <i className="fa fa-exclamation-circle"/> Form is read-only.</h6>}
            <div className="">
                <div>
                    <div className="li-form-label m-0 p-0">Created: <span className="li-fg-slightly-muted">
                        {(retrievalInfo?.createdOn)?LIUtils.dateToShortDateTimeString(retrievalInfo?.createdOn):" (now)"}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-5 pl-0">
                        <TextInput name="createdByName" label="Created By" readOnly onChange={onChange}
                                   placeholder=""
                                   value={retrievalInfo?.createdByName??""}
                                   required/>
                    </div>
                    <div className="col-7 offset-0">
                       <ContactFind widgetName="requestedBy" onContactSelected={onChange} tabIndex={1}
                                    initialValue={
                                        {   
                                            name:retrievalInfo?.requestedByName??"",
                                            id:retrievalInfo?.requestedById??-1,
                                        }
                                    }
                                    required readOnly={formIsReadOnly}/>
                    </div>
                </div>
                
               <LocationSelector name="ro" onChange={onChange} tabIndex={2}
                                 locationValue={retrievalInfo?.destLocation??""} 
                                 departmentValue={retrievalInfo?.destDepartment??""} 
                                 contactValue={retrievalInfo?.destContact??""}
                                 contactDefaultText="(none)"
                                 onIsValid={onLocationIsValidChanged}
                                 showOffPremises={false}
                                 required 
                                 readOnly={formIsReadOnly}
                                 onHelpClicked={handleLocationHelpClicked}/>
            </div>

            <NotesEditor name="notes" onChange={onChange} value={retrievalInfo?.notes??""} showAddButton={formIsReadOnly}
                         rows={3} tabIndex={4} onAddNoteClicked={onAddNoteClicked} readOnly={formIsReadOnly}/>
            {/*<TextArea name="notes" label="Notes" onChange={onChange} placeholder="" value={retrievalInfo?.notes??""} rows={3} tabIndex={4}/>*/}
            
            <div className="row m-0 p-0">
                <div className="col-12 col-sm-3">
                    <div className="li-form-label">Date Due Back</div>
                    <DatePicker className={dateControlInputClass} name="dueBackDate" clearIcon={null} calendarType="US"
                                onChange={onDateChanged} value={retrievalInfo?.dueBackDate??null} calendarIcon={<CalendarIcon/>}
                                required disabled={formIsReadOnly}/>
                    <medium className="form-text text-muted">* month/day/year</medium>
                </div>
                <div className="offset-0 offset-sm-1 col-12 col-sm-8">
                    <div className="card">
                        <div className="card-body li-bg-light">
                            <div className="row justify-content-around">
                                <div>
                                    <div className="li-form-label mt-0">Add Samples From Case...</div>
                                    <CaseFind onItemSelected={onAddSamples} name="caseFind"
                                              readOnly={formIsReadOnly}/>
                                    <medium className="form-text text-muted">* start typing (min 2 characters)</medium>
                                </div>
                                <div>
                                    <div className="li-form-label mt-0">...or Add Via Sample Barcode</div>
                                    <SampleBarcodeFind onItemSelected={onAddSamplesViaBarcode} name="sampleBCFind"
                                                readOnly={formIsReadOnly}/>
                                    <medium className="form-text text-muted">* start typing (min 4 characters)</medium>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="mt-4 li-slideblock-list">
                <div className="li-font-medium font-weight-bold">Samples On This Order</div>
                {dumpSelectedSamplesList()}
            </div>
            
            {dumpPermanentRemoveCheckBox()}
            
            <div className="row justify-content-center">
                {
                    !formIsReadOnly &&
                        <button type="button" id="addUpdateOrderBtn" className="li-button li-primary li-font-large px-5 mt-2 mb-4" onClick={onSubmit}
                                disabled={!(formIsValid && locationIsValid && isDirty)}>{isSaving?<LoadingSpinner small/> : isNewOrder()?"Add Order":"Update Order"}</button>
                }
            </div>
        </form>
    );
};

RetrievalOrderForm.propTypes = {
    retrievalInfo: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func, 
    goodNess: PropTypes.object,
    onAddSamples: PropTypes.func,
    onAddSamplesViaBarcode: PropTypes.func,
    formIsValid: PropTypes.bool,
    isSaving: PropTypes.bool,
    onDateChanged: PropTypes.func,
    onSampleClicked: PropTypes.func,
    onSampleOrderClicked: PropTypes.func,
    onSampleRepairClicked: PropTypes.func,
    onRemoveSample: PropTypes.func,
    formIsReadOnly: PropTypes.bool,
    isDirty: PropTypes.bool,
    onAddNoteClicked: PropTypes.func,
    newlyAddedSampleIds: PropTypes.array,
};

export default RetrievalOrderForm;